import * as _ from "lodash";
import React, { useEffect } from "react";
import * as ReactModal from "react-modal";
import Select, { components } from "react-select";
import * as Const from "../../../Constants";
import * as Models from "../../../Models";
import { OutotecIcons } from "../../General/Icons/";
import moment from "moment";
import { useState, useMemo } from "react";
import RequestChangeForAssetNotice from "./RequestChangeForAssetNotice";
import IBDatePicker from "../DatePicker";
import {
    useGetSellableProductModels,
    useSendNewAssetRequest,
} from "../../../Api/azure";
import { toast } from "react-toastify";

interface RequestNewAssetModalProps {
    open: boolean;
    activeDetail: Models.ActiveDetail;
    showLinkAddAsset: boolean;
    onClose: () => void;
}

const CustomDropdownIndicator = (props) => {
    const isMenuOpen = props.selectProps.menuIsOpen;

    return (
        <components.DropdownIndicator {...props}>
            {isMenuOpen ? (
                <OutotecIcons type={Const.CHEVRON_UP} />
            ) : (
                <OutotecIcons type={Const.CHEVRON_DOWN} />
            )}
        </components.DropdownIndicator>
    );
};

export default function RequestNewAssetModal(props: RequestNewAssetModalProps) {
    const siteId = props.showLinkAddAsset
        ? props.activeDetail?.detail?.locationId || ""
        : props.activeDetail?.detail?.id || "";

    const [formState, setFormState] = useState({
        globalProjectId: props.showLinkAddAsset
            ? props.activeDetail?.detail?.description
            : null,
        productId: "",
        serialNumber: "",
        operatingStatus: "",
        name: "",
        startUpDate: null,
        equipmentType: "",
        deliveryProjectId: "",
        customerTagNumber: "",
        notes: null,
    });
    const [showUserNoticeModal, setShowUserNoticeModal] =
        useState<boolean>(false);
    const [initialized, setInitialized] = useState<boolean>(false);
    const [products, setProducts] = useState<string[]>([]);
    const { mutate: sendAssetRequest } = useSendNewAssetRequest();
    // const { data: modelRevisions, isSuccess: isRevisionsSuccess } =
    //     useGetModelRevisions({
    //         enabled: true,
    //     });

    const { data: sellableModels, isSuccess: isSellableSuccess } =
        useGetSellableProductModels({
            enabled: true,
        });

    const productOptions = useMemo(() => {
        const isValid = (item) =>
            item.description && item.description.trim().length > 0;

        const sellableProductModelOptions =
            isSellableSuccess && sellableModels
                ? sellableModels.filter(isValid).map((m) => ({
                      label: m.description,
                      value: m.id,
                  }))
                : [];

        // const modelRevisionOptions =
        //     isRevisionsSuccess && modelRevisions
        //         ? modelRevisions.filter(isValid).map((m) => ({
        //               label: m.description,
        //               value: m.id,
        //           }))
        //         : [];

        return [...sellableProductModelOptions];
    }, [sellableModels]);
    useEffect(() => {
        if (productOptions.length > 0) {
            const sortedOptions = [...productOptions].sort((a, b) =>
                a.label.localeCompare(b.label)
            );
            setProducts(sortedOptions);

            setInitialized(true);
        }
    }, [productOptions]);

    const handleChange = (event) => {
        const name = event.target.name;
        const value =
            name.toLowerCase() === "serialnumber"
                ? event.target.value.trim().replace(" ", "")
                : event.target.value;

        setFormState((prevState) => ({
            ...prevState,
            [name]: value,
        }));
    };

    const handleDatePickerChange = (date: moment.Moment | Date) => {
        if (!date) return;
        const momentDate = moment(date);
        setFormState((prev) => ({
            ...prev,
            startUpDate: momentDate.format(Const.DATETIME_FORMAT),
        }));
    };
    const handleSelectChange = (option: any) => {
        setFormState((prev) => ({
            ...prev,
            productId: option.value,
        }));
    };
    const isValid = (): boolean => {
        return (
            siteId?.length > 0 &&
            formState.productId?.length > 0 &&
            formState.serialNumber?.length > 0 &&
            formState.operatingStatus?.length > 0 &&
            formState.name?.length > 0 &&
            formState.equipmentType?.length > 0 &&
            formState.startUpDate?.length > 0
        );
    };

    const create = (): void => {
        const data: Models.NewAssetRequest = {
            siteId: siteId,
            ...formState,
        };

        sendAssetRequest(data, {
            onSuccess: () => {
                toast.success("Asset creation request sent successfully!");
            },
            onError: (err) => {
                console.log("Error sending asset request:", err);
                toast.error(`Problem sending create asset request: ${err}`);
            },
        });
    };

    const handleUserShowNotice = (clicked: boolean): void => {
        if (clicked) {
            create();
        }
    };

    const handleShowUserNoticeModal = (e): void => {
        e.stopPropagation();
        setShowUserNoticeModal(true);
    };

    if (!props.open || !initialized) {
        return <></>;
    }
    const close: Function = (e) => {
        e.stopPropagation();
        props.onClose();
    };
    const label = props.showLinkAddAsset ? "Global project Id:" : "Site:";

    if (showUserNoticeModal === true) {
        return (
            <RequestChangeForAssetNotice
                open={true}
                handleUserShowNotice={handleUserShowNotice}
                onClose={props.onClose}
            />
        );
    }

    return (
        <ReactModal
            onRequestClose={() => props.onClose()}
            isOpen={props.open}
            contentLabel="Modal"
            style={{ content: { maxHeight: "100%", overflow: "auto" } }}
            defaultStyles={{}}
        >
            <div className="RequestNewAsset-container">
                <h2 className="Modal__header">Request new asset</h2>

                <div className="form-group">
                    <label className="tiny">{label}</label>
                    <input
                        readOnly
                        className="form-control"
                        value={props.activeDetail?.detail?.description}
                    />
                </div>
                {props.showLinkAddAsset ? (
                    <div className="form-group">
                        <label className="tiny">Site name</label>
                        <input
                            readOnly
                            className="form-control"
                            value={props.activeDetail?.detail?.siteName}
                        />
                    </div>
                ) : null}
                <div className="form-group">
                    <label className="tiny required">
                        Sellable product model:
                    </label>
                    <Select
                        isSearchable={true}
                        isClearable={false}
                        placeholder="Select..."
                        onChange={handleSelectChange}
                        options={products}
                        controlShouldRenderValue={true}
                        components={{
                            DropdownIndicator: CustomDropdownIndicator,
                        }}
                        styles={{
                            dropdownIndicator: (base) => ({
                                ...base,
                                padding: 8,
                                svg: {
                                    fill: "#009CD9",
                                    width: 17,
                                    height: 11,
                                },
                                cursor: "pointer",
                            }),
                            control: (styles, { isFocused }) => ({
                                ...styles,
                                borderColor: isFocused
                                    ? "lightgrey"
                                    : "lightgrey", // Remove blue border on focus
                                boxShadow: "none", // Remove any box shadow (blue highlight)
                                ":hover": {
                                    borderColor: "lightgrey",
                                },
                                minHeight: 35,
                            }),
                            placeholder: (styles) => ({
                                ...styles,
                                fontStyle: "italic",
                                color: "#ccc",
                            }),
                        }}
                    />
                </div>

                <div className="form-group">
                    <label className="tiny required">Serial number:</label>
                    <input
                        type="text"
                        name="serialNumber"
                        className="form-control"
                        onChange={handleChange}
                        value={formState.serialNumber}
                    />
                </div>

                <div className="form-group">
                    <label className="tiny required">
                        Asset descriptive name:
                    </label>
                    <input
                        type="text"
                        name="name"
                        className="form-control"
                        onChange={handleChange}
                        maxLength={40}
                    />
                </div>

                <div className="form-group">
                    <label className="tiny required">Operating status:</label>
                    <label className="input-container radio">
                        Operational
                        <input
                            name="operatingStatus"
                            value="Operational"
                            type="radio"
                            onChange={handleChange}
                        />
                        <span className="checkmark"></span>
                    </label>
                    <label className="input-container radio">
                        Inactive
                        <input
                            name="operatingStatus"
                            value="Inactive"
                            type="radio"
                            onChange={handleChange}
                        />
                        <span className="checkmark"></span>
                    </label>
                </div>

                <div className="form-group">
                    <label className="tiny required">
                        Estimated start up date:
                    </label>
                    <IBDatePicker
                        selected={
                            formState.startUpDate
                                ? moment(
                                      formState.startUpDate,
                                      Const.DATETIME_FORMAT
                                  )
                                : null
                        }
                        placeholder="Select a date"
                        onChange={handleDatePickerChange}
                    />
                </div>

                <div className="form-group">
                    <label className="tiny required">Equipment type:</label>
                    <label className="input-container radio">
                        Metso:Outotec
                        <input
                            name="equipmentType"
                            value="Z"
                            type="radio"
                            onChange={handleChange}
                        />
                        <span className="checkmark"></span>
                    </label>
                    <label className="input-container radio">
                        3rd Party
                        <input
                            name="equipmentType"
                            value="Y"
                            type="radio"
                            onChange={handleChange}
                        />
                        <span className="checkmark"></span>
                    </label>
                </div>
                {!props.showLinkAddAsset ? (
                    <div className="form-group">
                        <label className="tiny">Global project Id</label>
                        <input
                            type="text"
                            name="globalProjectId"
                            className="form-control"
                            onChange={handleChange}
                            maxLength={40}
                        />
                    </div>
                ) : null}
                <div className="form-group">
                    <label className="tiny">Delivery project Id</label>
                    <input
                        type="text"
                        name="deliveryProjectId"
                        className="form-control"
                        onChange={handleChange}
                        maxLength={40}
                    />
                </div>
                <div className="form-group">
                    <label className="tiny">Customer tag number</label>
                    <input
                        type="text"
                        name="customerTagNumber"
                        className="form-control"
                        onChange={handleChange}
                        maxLength={40}
                    />
                </div>

                <div className="form-group">
                    <label className="tiny">Notes to master data team:</label>
                    <input
                        type="text"
                        name="notes"
                        className="form-control"
                        onChange={handleChange}
                    />
                </div>

                <div className="Modal__buttonGroup">
                    <button
                        className="btn btn-secondary"
                        onClick={(e) => close(e)}
                    >
                        Cancel
                    </button>
                    <button
                        className="btn btn-primary float-end"
                        onClick={(e) => handleShowUserNoticeModal(e)}
                        disabled={!isValid()}
                    >
                        Send
                    </button>
                </div>
            </div>
        </ReactModal>
    );
}
